import React from 'react';
import { Typography, Box } from '@mui/material';

const PolicyModalContent = () => {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography paragraph fontWeight="bold">
        Welcome Valued Shared Table Users
      </Typography>

      <Typography paragraph>
        Shared Table provides Standard Supplier Program suppliers and their broker partners with custom data tailored to your individual business with US Foods. As we've launched the Standard Supplier Program, specific to that program, our user license agreement is now available below. For current Shared Table users who utilize Shared Table Portfolio and Category, the terms and conditions of your negotiated Shared Table Agreement shall control for those specific programs.
      </Typography>

      <Typography paragraph>
        Even if you are not participating in the Standard Supplier Program, the system will require you to review and process the below. However, the below does not apply to you and does not change or otherwise modify your Shared Table Agreement.
      </Typography>

      <Typography paragraph fontWeight="bold" sx={{ mt: 3 }}>
        US Foods Standard Supplier Program Shared Table User License Agreement
      </Typography>

      <Typography paragraph>
        <strong>1. Service Provider's Obligations</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) "Service Provider" and "US Foods" both mean US Foods, Inc., a Delaware corporation whose principal place of business is 9399 West Higgins Road, Suite 100, Rosemont, IL 60018, together with its subsidiaries and affiliates.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) The Service Provider reserves the right to upgrade the Deliverables as it deems necessary from time to time including by way of additions to or replacement of Deliverables. Deliverables are the Transaction Data and Documentation housed in the Shared Table platform. "Transaction Data" means all US Foods sales, inventory, compliance and descriptive dimensions data, including, but not limited to, metrics, geographies, quality tiers and pyramids, made available by US Foods for inclusion in the Deliverables. "Documentation" means any copy, version or translation, in whole or in part, of any documentation provided by the Service Provider in relation to the Deliverables.
      </Typography>

      <Typography paragraph>
        <strong>2. Permitted Purpose</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) The End User expressly acknowledges and agrees that only those employees who require access to the Transaction Data and Documentation for the Permitted Purpose. End User means those persons employed by the supplier or broker who require access to the Deliverables. For greater certainty, a person who works solely on matters unrelated to US Foods shall not qualify as an End User and shall not be granted access to the Deliverables or any information derived therefrom.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) The End User acknowledges that the Deliverables are confidential and proprietary information of US Foods.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (c) The End User shall not use the Deliverables except as expressly permitted in this Agreement. End User shall not, at any time, directly or indirectly:
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (i) translate, adapt, copy, modify, or create derivative works from, recreate any component or part of, or unlock the Deliverables, in whole or in part;
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (ii) encumber, rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make available the Deliverables;
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (iii) reverse engineer, disassemble, decompile, decode, adapt, or otherwise attempt to derive or gain access to the source code of any software embodied in or used in the Deliverables, in whole or in part;
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (iv) remove, alter, cover or obscure any confidentiality, trademark, logo, copyright, patent or other proprietary notices, legends, symbols or labels in the Deliverables;
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (v) use the Deliverables (or any information or Transaction Data derived therefrom) or the Documentation in connection with any matter unrelated to US Foods or in any manner that is detrimental to the interests of US Foods or for any purpose that infringes, misappropriates, or otherwise violates any intellectual property right or other right of any person, or that violates any applicable law.
      </Typography>

      <Typography paragraph>
        <strong>3. License</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) The Service Provider grants the End User a non-exclusive, non-transferable, revocable license to access and use the Deliverables solely for the User's internal business purposes, subject to the terms of this Agreement.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) The Service Provider and its licensors retain all ownership and/or proprietary rights, including all intellectual property rights, in and to the Deliverables. This Agreement does not grant to the End User any license under any patents or other intellectual property rights the Service Provider may own or control or which may be licensed to the Service Provider other than the limited rights of use expressly granted in this Agreement.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (c) For the avoidance of doubt, as between the Service Provider and the End User, the intellectual property rights (including without limitation, copyright and database rights that arise in the future) in all methodologies (including workflow methodologies and improvements thereto), formats, software, tools, structures and design protocols embodied in or used in (or created during the provision of) the Deliverables shall remain vested in the Service Provider.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (d) The End User shall follow all reasonable instructions given by the Service Provider from time to time with regard to the use of trademarks owned by the Service Provider and other indications of the property and rights of the Service Provider.
      </Typography>

      <Typography paragraph>
        <strong>4. Confidential Information</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) Neither party, Service Provider or End User, will disclose to any third party any Confidential Information which is received from the other without the other's prior written consent, and will only use such Confidential Information for the purposes of fulfilling obligations under this Agreement.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) Both parties agree that the Confidential Information may be disclosed to employees only on a "need to know" basis and provided that such employees are already subject to an express duty of confidentiality to the End User.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (c) Notwithstanding this Section 4, either party will be entitled to disclose Confidential Information of the other to:
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (i) its insurers or legal or accounting advisors; or
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (ii) any third party as a result of governmental or legal requirements, provided that where reasonably practicable not less than 2 business days' notice is first given to the other and all reasonable non-financial cooperation is given in order to allow the affected party to seek a protective order or other form of protection prior to disclosure.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (d) Any use of Confidential Information obtained from the Deliverables in accordance with this Section 4 should be referred to as "Source: © US Foods, Inc. [date]/Private & Confidential".
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (e) The provisions of this Section 4 shall survive termination or expiry of this Agreement.
      </Typography>

      <Typography paragraph>
        <strong>5. Warranties and Disclaimers</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) The Service Provider warrants that the Deliverables will be delivered in accordance with good industry practice. The End User is responsible for using compatible and properly configured equipment to access the Deliverables. The End User's sole and exclusive remedy for breach of any of the foregoing provisions of this Section 5 shall be for the Service Provider to use reasonable efforts to repair such nonconformities within a reasonable time after the End User provides notice of such breach and if the breach relates to a software error, sufficient information for the Service Provider to replicate the error.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) The Service Provider represents and warrants that:
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (i) it has the right to enter into this Agreement;
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (ii) the provision of the Deliverables shall not conflict with the terms of any relationship or contract between the Service Provider and any third party;
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (iii) the Service Provider will comply with all applicable laws and regulations relating to the Deliverables; and
      </Typography>

      <Typography paragraph sx={{ pl: 4 }}>
        (iv) the provision of the Deliverables and the use thereof by the End User in accordance with this Agreement will not infringe the intellectual property rights of any third party.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (c) Except as expressly set forth herein, all conditions, warranties, terms and undertakings, express or implied, statutory or otherwise, are hereby excluded to the extent permitted by law, including but not limited to any implied warranties of merchantability or fitness for a particular purpose.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (d) The Service Provider does not warrant that the Deliverables will meet the End User's requirements.
      </Typography>

      <Typography paragraph>
        <strong>6. Term and Termination of Agreement</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) Service Provider may terminate this Agreement upon written notice to End User.
      </Typography>

      <Typography paragraph>
        <strong>7. Limitation of Liability</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) Any unauthorized disclosure or distribution of the Deliverables would cause irreparable harm to Service Provider. End User acknowledges and agrees that monetary damages may not be a sufficient remedy for any breach of this Agreement by End User and that in addition to all other remedies it may be entitled to (which Service Provider does not waive by the exercise of any rights under this section), Service Provider shall be entitled to seek specific performance and injunctive or other equitable relief as a remedy for any such breach or threatened breach.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) In no event will Service Provider be liable for any direct, indirect, incidental, special or consequential damages, including direct monetary damages, damages for loss of profits, revenue, data or data use, even if advised of the possibility of such damages.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (c) Despite the Service Provider's acceptance of certain liabilities, it will not be responsible to the End User for any loss or damage caused as a result of any failure to perform, or improper performance of, its obligations under this Agreement where such failure or improper performance is not its fault or is due to unusual or unforeseeable circumstances beyond its control or attributable to the End User or a third party.
      </Typography>

      <Typography paragraph>
        <strong>8. Force Majeure</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) Neither party shall be held liable or responsible to the other party nor deemed to be in default or breach of this Agreement for failure or delay in fulfilling or performing any of its obligations under this Agreement to the extent, and for so long as, such failure or delay is caused by or results from causes beyond the reasonable control of the affected party including, but not limited to, any act of God, fire, epidemic, natural disaster, accident, terrorism, war, acts of war (whether war be declared or not), insurrections, riots, civil commotion, strikes, lockouts or other labor disturbances or any acts, omissions or delays in activity by any governmental authority or the other party provided that should such an event continue for longer than three months, the party adversely affected shall have the option of terminating this Agreement immediately without further liability other than such liabilities as have already accrued at the date of termination. Notwithstanding the foregoing, force majeure shall in no event exempt any party from any obligation to pay, or excuse any failure to pay, any amount payable hereunder when due.
      </Typography>

      <Typography paragraph>
        <strong>9. General Provisions</strong>
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (a) Nothing in this Agreement shall create any association, partnership, joint venture, employer-employee or agent-principal relationship between the parties.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (b) If any provision of this Agreement is held to be invalid, the remaining provisions shall remain in full force and effect.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (c) A person who is not a party to this Agreement has no right to enforce any term of this Agreement.
      </Typography>

      <Typography paragraph sx={{ pl: 2 }}>
        (d) This Agreement and the rights of the parties hereunder shall be governed by and interpreted in accordance with the laws of the State of Delaware, without giving effect to principals of conflicts of laws. The federal and/or state courts of Delaware shall have exclusive personal and subject matter jurisdiction over, and the parties each hereby submit to the venue of such courts with respect to, any dispute arising out of or relating to this Agreement, and all objections to such jurisdiction and venue are hereby waived. The End User consents to service of process permitted under Delaware law or by certified mail, return receipt requested.
      </Typography>
    </Box>
  );
};

export default PolicyModalContent;
